import "./VenueInfoComp.css";
import { IoLocationOutline } from "react-icons/io5";
import { FaDirections } from "react-icons/fa";
import { API_BASE_URL, openInGoogleMaps } from "../../utils";

const baseurl = `${API_BASE_URL}/master/assets/uploads/`;

const VenueInfoComp = ({ orderData }) => {
  return (
    <aside className="pslis-container-comp">
      {/* Venue details */}
      <div className="pslis-venue">
        <div className="pslis-venue-title">
          <span className="pslis-venue-logo">
            <img
              src={baseurl + orderData?.clubLogo}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src =
                  "https://images.unsplash.com/photo-1581417478175-a9ef18f210c2?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8Y2x1YnxlbnwwfHwwfHx8MA%3D%3D";
              }}
              alt="club_logo"
            />
          </span>
          {orderData?.clubName || orderData?.club_name}
          {orderData?.club_rating > 0 && (
            <span className="pslis-star">★ {orderData?.club_rating}</span>
          )}
        </div>
        {orderData?.club_review > 0 && (
          <div className="pslis-reviews">Review ({orderData?.club_review})</div>
        )}
      </div>

      {/* Address */}
      <div className="pslis-address">
        <span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            viewBox="0 0 14 16"
            fill="none">
            <path
              d="M12.8346 6.83333C12.8346 11.3704 7.0013 15.2593 7.0013 15.2593C7.0013 15.2593 1.16797 11.3704 1.16797 6.83333C1.16797 5.28624 1.78255 3.80251 2.87651 2.70854C3.97047 1.61458 5.45421 1 7.0013 1C8.5484 1 10.0321 1.61458 11.1261 2.70854C12.2201 3.80251 12.8346 5.28624 12.8346 6.83333Z"
              stroke="#4F4F4F"
              stroke-width="1.16667"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M7.00304 8.77756C8.07692 8.77756 8.94748 7.907 8.94748 6.83312C8.94748 5.75923 8.07692 4.88867 7.00304 4.88867C5.92915 4.88867 5.05859 5.75923 5.05859 6.83312C5.05859 7.907 5.92915 8.77756 7.00304 8.77756Z"
              stroke="#4F4F4F"
              stroke-width="1.16667"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>
        {orderData?.club_address}
      </div>

      {/* Actions */}
      {/* <div className="pslis-actions">
                <div className="pslis-distance">
                    <FaDirections /> {Math.round(parseFloat(orderData?.distance || 0))} Kms
                </div>
      
            </div> */}
    </aside>
  );
};

export default VenueInfoComp;
